import { render } from "./MalaCats.vue?vue&type=template&id=55a92015&scoped=true"
import script from "./MalaCats.vue?vue&type=script&lang=js"
export * from "./MalaCats.vue?vue&type=script&lang=js"

import "./MalaCats.vue?vue&type=style&index=0&id=55a92015&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a92015"]])

export default __exports__